<div id="manage-courses-dialog">
  <div class="title">{{ title }}</div>
  <div class="mixed-selection" *ngIf="isSelectionMixed">
    <i class="material-icons">warning</i>
    <span>{{ 'You have selected students with different course assignments. Any changes will overwrite previous actions.' | translate }}</span>
  </div>
  <div class="search-wrap">
    <div class="search">
      <input
        #searchCourses
        [placeholder]="'Search course name' | translate"
        (keyup)="handleSearch(searchCourses.value)"
      />
      <i style="cursor: pointer" class="material-icons">search</i>
    </div>
  </div>
  <div class="courses">
    <div
      class="course"
      *ngFor="let course of filteredCourses"
      [ngClass]="{ selected: courseSelectionState(course._id) !== 'none'}"
    >
      <div class="inner">
        <div class="name">{{ course.name }}</div>
      </div>
      <mat-checkbox
        color="primary"
        [checked]="courseSelectionState(course._id) === 'all'"
        [indeterminate]="courseSelectionState(course._id) === 'partial'"
        (change)="handleCourseClick(course._id, $event)"
      ></mat-checkbox>
    </div>
  </div>
  <div class="footer">
    <span
      >{{ checkedCourses }}
      {{ checkedCourses === 1 ? ('course' | translate) : ('courses' | translate)}} {{ 'selected' | translate }}</span
    >
    <div class="buttons">
      <button mat-flat-button (click)="close()">
        <span class="material-icons">close</span>
        {{'Cancel' | translate}}
      </button>
      <button
        mat-flat-button
        class="done"
        (click)="submit()"
      >
        <span class="material-icons">done</span>
        {{'Done' | translate}}
      </button>
    </div>
  </div>
</div>
